import VisaMastercardIcon from "@assets/icons/methods/VisaMastercardIcon";
import TetherTRCIcon from "@assets/icons/methods/TetherTRCIcon";
import TetherBEPIcon from "@assets/icons/methods/TetherBEPIcon";
import TetherERCIcon from "@assets/icons/methods/TetherERCIcon";
import EthereumERCIcon from "@assets/icons/methods/EthereumERCIcon";
import USDCoinBEPIcon from "@assets/icons/methods/USDCoinBEPIcon";
import USDCoinERCIcon from "@assets/icons/methods/USDCoinERCIcon";
import USDCoinBaseIcon from "@assets/icons/methods/USDCoinBaseIcon";
import BitcoinIcon from "@assets/icons/methods/BitcoinIcon";
import TronIcon from "@assets/icons/methods/TronIcon";
import LitecoinIcon from "@assets/icons/methods/LitecoinIcon";

export const paymentMethodLogos = {
  visa_uah: VisaMastercardIcon,
  visa_usd: VisaMastercardIcon,

  usdt_trc20: TetherTRCIcon,
  usdt_bep20: TetherBEPIcon,
  usdt_erc20: TetherERCIcon,
  eth_erc20: EthereumERCIcon,
  usdc_bep20: USDCoinBEPIcon,
  usdc_erc20: USDCoinERCIcon,
  usdc_base: USDCoinBaseIcon,
  btc: BitcoinIcon,
  ton: "/images/Toncoin.png",
  trx: TronIcon,
  ltc: LitecoinIcon,
  eth_base: EthereumERCIcon,
};

export const getMethodLogo = (method) => {
  return (
    paymentMethodLogos[method?.method_key] ||
    paymentMethodLogos[method?.slug] ||
    method?.logo
  );
};
